import FileType from '../types/FileType';

export const root: FileType = {
    Id: '',
    Name: 'root',
    Extension: 'folder',
};

export const navigationHistory: FileType[] = [root];
